// source: legebill/site/activitytype/v4/activity_type.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_api_annotations_pb = require('../../../../google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var legebill_type_activity_type_pb = require('../../../../legebill/type/activity_type_pb.js');
goog.object.extend(proto, legebill_type_activity_type_pb);
goog.exportSymbol('proto.legebill.site.activitytype.v4.CreateFavouriteActivityTypeRequest', null, global);
goog.exportSymbol('proto.legebill.site.activitytype.v4.DeleteFavouriteActivityTypeRequest', null, global);
goog.exportSymbol('proto.legebill.site.activitytype.v4.FavouriteActivityType', null, global);
goog.exportSymbol('proto.legebill.site.activitytype.v4.GetActivityTypeRequest', null, global);
goog.exportSymbol('proto.legebill.site.activitytype.v4.ListActivityTypesRequest', null, global);
goog.exportSymbol('proto.legebill.site.activitytype.v4.ListActivityTypesResponse', null, global);
goog.exportSymbol('proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesRequest', null, global);
goog.exportSymbol('proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesResponse', null, global);
goog.exportSymbol('proto.legebill.site.activitytype.v4.ListRecentActivityTypesRequest', null, global);
goog.exportSymbol('proto.legebill.site.activitytype.v4.ListRecentActivityTypesResponse', null, global);
goog.exportSymbol('proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeRequest', null, global);
goog.exportSymbol('proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeResponse', null, global);
goog.exportSymbol('proto.legebill.site.activitytype.v4.SearchActivityTypesRequest', null, global);
goog.exportSymbol('proto.legebill.site.activitytype.v4.SearchActivityTypesRequest.OrderBy', null, global);
goog.exportSymbol('proto.legebill.site.activitytype.v4.SearchActivityTypesResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.activitytype.v4.ListActivityTypesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.activitytype.v4.ListActivityTypesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.activitytype.v4.ListActivityTypesRequest.displayName = 'proto.legebill.site.activitytype.v4.ListActivityTypesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.activitytype.v4.ListActivityTypesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.legebill.site.activitytype.v4.ListActivityTypesResponse.repeatedFields_, null);
};
goog.inherits(proto.legebill.site.activitytype.v4.ListActivityTypesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.activitytype.v4.ListActivityTypesResponse.displayName = 'proto.legebill.site.activitytype.v4.ListActivityTypesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.activitytype.v4.SearchActivityTypesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.activitytype.v4.SearchActivityTypesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.activitytype.v4.SearchActivityTypesRequest.displayName = 'proto.legebill.site.activitytype.v4.SearchActivityTypesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.activitytype.v4.SearchActivityTypesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.legebill.site.activitytype.v4.SearchActivityTypesResponse.repeatedFields_, null);
};
goog.inherits(proto.legebill.site.activitytype.v4.SearchActivityTypesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.activitytype.v4.SearchActivityTypesResponse.displayName = 'proto.legebill.site.activitytype.v4.SearchActivityTypesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesRequest.displayName = 'proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesResponse.repeatedFields_, null);
};
goog.inherits(proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesResponse.displayName = 'proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.activitytype.v4.FavouriteActivityType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.activitytype.v4.FavouriteActivityType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.activitytype.v4.FavouriteActivityType.displayName = 'proto.legebill.site.activitytype.v4.FavouriteActivityType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.activitytype.v4.CreateFavouriteActivityTypeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.activitytype.v4.CreateFavouriteActivityTypeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.activitytype.v4.CreateFavouriteActivityTypeRequest.displayName = 'proto.legebill.site.activitytype.v4.CreateFavouriteActivityTypeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeRequest.displayName = 'proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeResponse.displayName = 'proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.activitytype.v4.DeleteFavouriteActivityTypeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.activitytype.v4.DeleteFavouriteActivityTypeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.activitytype.v4.DeleteFavouriteActivityTypeRequest.displayName = 'proto.legebill.site.activitytype.v4.DeleteFavouriteActivityTypeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.activitytype.v4.ListRecentActivityTypesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.activitytype.v4.ListRecentActivityTypesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.activitytype.v4.ListRecentActivityTypesRequest.displayName = 'proto.legebill.site.activitytype.v4.ListRecentActivityTypesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.activitytype.v4.ListRecentActivityTypesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.legebill.site.activitytype.v4.ListRecentActivityTypesResponse.repeatedFields_, null);
};
goog.inherits(proto.legebill.site.activitytype.v4.ListRecentActivityTypesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.activitytype.v4.ListRecentActivityTypesResponse.displayName = 'proto.legebill.site.activitytype.v4.ListRecentActivityTypesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.legebill.site.activitytype.v4.GetActivityTypeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.legebill.site.activitytype.v4.GetActivityTypeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.legebill.site.activitytype.v4.GetActivityTypeRequest.displayName = 'proto.legebill.site.activitytype.v4.GetActivityTypeRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.activitytype.v4.ListActivityTypesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.activitytype.v4.ListActivityTypesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.activitytype.v4.ListActivityTypesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.activitytype.v4.ListActivityTypesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.activitytype.v4.ListActivityTypesRequest}
 */
proto.legebill.site.activitytype.v4.ListActivityTypesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.activitytype.v4.ListActivityTypesRequest;
  return proto.legebill.site.activitytype.v4.ListActivityTypesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.activitytype.v4.ListActivityTypesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.activitytype.v4.ListActivityTypesRequest}
 */
proto.legebill.site.activitytype.v4.ListActivityTypesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = /** @type {!proto.legebill.type.ActivityType.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.activitytype.v4.ListActivityTypesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.activitytype.v4.ListActivityTypesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.activitytype.v4.ListActivityTypesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.activitytype.v4.ListActivityTypesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.legebill.site.activitytype.v4.ListActivityTypesRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.activitytype.v4.ListActivityTypesRequest} returns this
 */
proto.legebill.site.activitytype.v4.ListActivityTypesRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional legebill.type.ActivityType.Status status = 2;
 * @return {!proto.legebill.type.ActivityType.Status}
 */
proto.legebill.site.activitytype.v4.ListActivityTypesRequest.prototype.getStatus = function() {
  return /** @type {!proto.legebill.type.ActivityType.Status} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.legebill.type.ActivityType.Status} value
 * @return {!proto.legebill.site.activitytype.v4.ListActivityTypesRequest} returns this
 */
proto.legebill.site.activitytype.v4.ListActivityTypesRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.legebill.site.activitytype.v4.ListActivityTypesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.activitytype.v4.ListActivityTypesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.activitytype.v4.ListActivityTypesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.activitytype.v4.ListActivityTypesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.activitytype.v4.ListActivityTypesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    activityTypesList: jspb.Message.toObjectList(msg.getActivityTypesList(),
    legebill_type_activity_type_pb.ActivityType.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.activitytype.v4.ListActivityTypesResponse}
 */
proto.legebill.site.activitytype.v4.ListActivityTypesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.activitytype.v4.ListActivityTypesResponse;
  return proto.legebill.site.activitytype.v4.ListActivityTypesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.activitytype.v4.ListActivityTypesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.activitytype.v4.ListActivityTypesResponse}
 */
proto.legebill.site.activitytype.v4.ListActivityTypesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new legebill_type_activity_type_pb.ActivityType;
      reader.readMessage(value,legebill_type_activity_type_pb.ActivityType.deserializeBinaryFromReader);
      msg.addActivityTypes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.activitytype.v4.ListActivityTypesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.activitytype.v4.ListActivityTypesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.activitytype.v4.ListActivityTypesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.activitytype.v4.ListActivityTypesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActivityTypesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      legebill_type_activity_type_pb.ActivityType.serializeBinaryToWriter
    );
  }
};


/**
 * repeated legebill.type.ActivityType activity_types = 1;
 * @return {!Array<!proto.legebill.type.ActivityType>}
 */
proto.legebill.site.activitytype.v4.ListActivityTypesResponse.prototype.getActivityTypesList = function() {
  return /** @type{!Array<!proto.legebill.type.ActivityType>} */ (
    jspb.Message.getRepeatedWrapperField(this, legebill_type_activity_type_pb.ActivityType, 1));
};


/**
 * @param {!Array<!proto.legebill.type.ActivityType>} value
 * @return {!proto.legebill.site.activitytype.v4.ListActivityTypesResponse} returns this
*/
proto.legebill.site.activitytype.v4.ListActivityTypesResponse.prototype.setActivityTypesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.legebill.type.ActivityType=} opt_value
 * @param {number=} opt_index
 * @return {!proto.legebill.type.ActivityType}
 */
proto.legebill.site.activitytype.v4.ListActivityTypesResponse.prototype.addActivityTypes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.legebill.type.ActivityType, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.site.activitytype.v4.ListActivityTypesResponse} returns this
 */
proto.legebill.site.activitytype.v4.ListActivityTypesResponse.prototype.clearActivityTypesList = function() {
  return this.setActivityTypesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.activitytype.v4.SearchActivityTypesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.activitytype.v4.SearchActivityTypesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.activitytype.v4.SearchActivityTypesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.activitytype.v4.SearchActivityTypesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    searchText: jspb.Message.getFieldWithDefault(msg, 2, ""),
    pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0),
    orderBy: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.activitytype.v4.SearchActivityTypesRequest}
 */
proto.legebill.site.activitytype.v4.SearchActivityTypesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.activitytype.v4.SearchActivityTypesRequest;
  return proto.legebill.site.activitytype.v4.SearchActivityTypesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.activitytype.v4.SearchActivityTypesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.activitytype.v4.SearchActivityTypesRequest}
 */
proto.legebill.site.activitytype.v4.SearchActivityTypesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearchText(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 4:
      var value = /** @type {!proto.legebill.site.activitytype.v4.SearchActivityTypesRequest.OrderBy} */ (reader.readEnum());
      msg.setOrderBy(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.activitytype.v4.SearchActivityTypesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.activitytype.v4.SearchActivityTypesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.activitytype.v4.SearchActivityTypesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.activitytype.v4.SearchActivityTypesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSearchText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getOrderBy();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.legebill.site.activitytype.v4.SearchActivityTypesRequest.OrderBy = {
  ORDER_BY_UNSPECIFIED: 0,
  RELEVANCE: 1,
  LABEL: 2
};

/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.legebill.site.activitytype.v4.SearchActivityTypesRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.activitytype.v4.SearchActivityTypesRequest} returns this
 */
proto.legebill.site.activitytype.v4.SearchActivityTypesRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string search_text = 2;
 * @return {string}
 */
proto.legebill.site.activitytype.v4.SearchActivityTypesRequest.prototype.getSearchText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.activitytype.v4.SearchActivityTypesRequest} returns this
 */
proto.legebill.site.activitytype.v4.SearchActivityTypesRequest.prototype.setSearchText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 page_size = 3;
 * @return {number}
 */
proto.legebill.site.activitytype.v4.SearchActivityTypesRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.legebill.site.activitytype.v4.SearchActivityTypesRequest} returns this
 */
proto.legebill.site.activitytype.v4.SearchActivityTypesRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional OrderBy order_by = 4;
 * @return {!proto.legebill.site.activitytype.v4.SearchActivityTypesRequest.OrderBy}
 */
proto.legebill.site.activitytype.v4.SearchActivityTypesRequest.prototype.getOrderBy = function() {
  return /** @type {!proto.legebill.site.activitytype.v4.SearchActivityTypesRequest.OrderBy} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.legebill.site.activitytype.v4.SearchActivityTypesRequest.OrderBy} value
 * @return {!proto.legebill.site.activitytype.v4.SearchActivityTypesRequest} returns this
 */
proto.legebill.site.activitytype.v4.SearchActivityTypesRequest.prototype.setOrderBy = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.legebill.site.activitytype.v4.SearchActivityTypesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.activitytype.v4.SearchActivityTypesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.activitytype.v4.SearchActivityTypesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.activitytype.v4.SearchActivityTypesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.activitytype.v4.SearchActivityTypesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    activityTypesList: jspb.Message.toObjectList(msg.getActivityTypesList(),
    legebill_type_activity_type_pb.ActivityType.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.activitytype.v4.SearchActivityTypesResponse}
 */
proto.legebill.site.activitytype.v4.SearchActivityTypesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.activitytype.v4.SearchActivityTypesResponse;
  return proto.legebill.site.activitytype.v4.SearchActivityTypesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.activitytype.v4.SearchActivityTypesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.activitytype.v4.SearchActivityTypesResponse}
 */
proto.legebill.site.activitytype.v4.SearchActivityTypesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new legebill_type_activity_type_pb.ActivityType;
      reader.readMessage(value,legebill_type_activity_type_pb.ActivityType.deserializeBinaryFromReader);
      msg.addActivityTypes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.activitytype.v4.SearchActivityTypesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.activitytype.v4.SearchActivityTypesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.activitytype.v4.SearchActivityTypesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.activitytype.v4.SearchActivityTypesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActivityTypesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      legebill_type_activity_type_pb.ActivityType.serializeBinaryToWriter
    );
  }
};


/**
 * repeated legebill.type.ActivityType activity_types = 1;
 * @return {!Array<!proto.legebill.type.ActivityType>}
 */
proto.legebill.site.activitytype.v4.SearchActivityTypesResponse.prototype.getActivityTypesList = function() {
  return /** @type{!Array<!proto.legebill.type.ActivityType>} */ (
    jspb.Message.getRepeatedWrapperField(this, legebill_type_activity_type_pb.ActivityType, 1));
};


/**
 * @param {!Array<!proto.legebill.type.ActivityType>} value
 * @return {!proto.legebill.site.activitytype.v4.SearchActivityTypesResponse} returns this
*/
proto.legebill.site.activitytype.v4.SearchActivityTypesResponse.prototype.setActivityTypesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.legebill.type.ActivityType=} opt_value
 * @param {number=} opt_index
 * @return {!proto.legebill.type.ActivityType}
 */
proto.legebill.site.activitytype.v4.SearchActivityTypesResponse.prototype.addActivityTypes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.legebill.type.ActivityType, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.site.activitytype.v4.SearchActivityTypesResponse} returns this
 */
proto.legebill.site.activitytype.v4.SearchActivityTypesResponse.prototype.clearActivityTypesList = function() {
  return this.setActivityTypesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesRequest}
 */
proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesRequest;
  return proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesRequest}
 */
proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesRequest} returns this
 */
proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    favouriteActivityTypesList: jspb.Message.toObjectList(msg.getFavouriteActivityTypesList(),
    proto.legebill.site.activitytype.v4.FavouriteActivityType.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesResponse}
 */
proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesResponse;
  return proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesResponse}
 */
proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.legebill.site.activitytype.v4.FavouriteActivityType;
      reader.readMessage(value,proto.legebill.site.activitytype.v4.FavouriteActivityType.deserializeBinaryFromReader);
      msg.addFavouriteActivityTypes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFavouriteActivityTypesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.legebill.site.activitytype.v4.FavouriteActivityType.serializeBinaryToWriter
    );
  }
};


/**
 * repeated FavouriteActivityType favourite_activity_types = 1;
 * @return {!Array<!proto.legebill.site.activitytype.v4.FavouriteActivityType>}
 */
proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesResponse.prototype.getFavouriteActivityTypesList = function() {
  return /** @type{!Array<!proto.legebill.site.activitytype.v4.FavouriteActivityType>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.legebill.site.activitytype.v4.FavouriteActivityType, 1));
};


/**
 * @param {!Array<!proto.legebill.site.activitytype.v4.FavouriteActivityType>} value
 * @return {!proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesResponse} returns this
*/
proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesResponse.prototype.setFavouriteActivityTypesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.legebill.site.activitytype.v4.FavouriteActivityType=} opt_value
 * @param {number=} opt_index
 * @return {!proto.legebill.site.activitytype.v4.FavouriteActivityType}
 */
proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesResponse.prototype.addFavouriteActivityTypes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.legebill.site.activitytype.v4.FavouriteActivityType, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesResponse} returns this
 */
proto.legebill.site.activitytype.v4.ListFavouriteActivityTypesResponse.prototype.clearFavouriteActivityTypesList = function() {
  return this.setFavouriteActivityTypesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.activitytype.v4.FavouriteActivityType.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.activitytype.v4.FavouriteActivityType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.activitytype.v4.FavouriteActivityType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.activitytype.v4.FavouriteActivityType.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    activityType: (f = msg.getActivityType()) && legebill_type_activity_type_pb.ActivityType.toObject(includeInstance, f),
    createTime: (f = msg.getCreateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.activitytype.v4.FavouriteActivityType}
 */
proto.legebill.site.activitytype.v4.FavouriteActivityType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.activitytype.v4.FavouriteActivityType;
  return proto.legebill.site.activitytype.v4.FavouriteActivityType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.activitytype.v4.FavouriteActivityType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.activitytype.v4.FavouriteActivityType}
 */
proto.legebill.site.activitytype.v4.FavouriteActivityType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new legebill_type_activity_type_pb.ActivityType;
      reader.readMessage(value,legebill_type_activity_type_pb.ActivityType.deserializeBinaryFromReader);
      msg.setActivityType(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.activitytype.v4.FavouriteActivityType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.activitytype.v4.FavouriteActivityType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.activitytype.v4.FavouriteActivityType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.activitytype.v4.FavouriteActivityType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getActivityType();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      legebill_type_activity_type_pb.ActivityType.serializeBinaryToWriter
    );
  }
  f = message.getCreateTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.legebill.site.activitytype.v4.FavouriteActivityType.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.activitytype.v4.FavouriteActivityType} returns this
 */
proto.legebill.site.activitytype.v4.FavouriteActivityType.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional legebill.type.ActivityType activity_type = 2;
 * @return {?proto.legebill.type.ActivityType}
 */
proto.legebill.site.activitytype.v4.FavouriteActivityType.prototype.getActivityType = function() {
  return /** @type{?proto.legebill.type.ActivityType} */ (
    jspb.Message.getWrapperField(this, legebill_type_activity_type_pb.ActivityType, 2));
};


/**
 * @param {?proto.legebill.type.ActivityType|undefined} value
 * @return {!proto.legebill.site.activitytype.v4.FavouriteActivityType} returns this
*/
proto.legebill.site.activitytype.v4.FavouriteActivityType.prototype.setActivityType = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.legebill.site.activitytype.v4.FavouriteActivityType} returns this
 */
proto.legebill.site.activitytype.v4.FavouriteActivityType.prototype.clearActivityType = function() {
  return this.setActivityType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.legebill.site.activitytype.v4.FavouriteActivityType.prototype.hasActivityType = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp create_time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.legebill.site.activitytype.v4.FavouriteActivityType.prototype.getCreateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.legebill.site.activitytype.v4.FavouriteActivityType} returns this
*/
proto.legebill.site.activitytype.v4.FavouriteActivityType.prototype.setCreateTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.legebill.site.activitytype.v4.FavouriteActivityType} returns this
 */
proto.legebill.site.activitytype.v4.FavouriteActivityType.prototype.clearCreateTime = function() {
  return this.setCreateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.legebill.site.activitytype.v4.FavouriteActivityType.prototype.hasCreateTime = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.activitytype.v4.CreateFavouriteActivityTypeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.activitytype.v4.CreateFavouriteActivityTypeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.activitytype.v4.CreateFavouriteActivityTypeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.activitytype.v4.CreateFavouriteActivityTypeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    activityTypeId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.activitytype.v4.CreateFavouriteActivityTypeRequest}
 */
proto.legebill.site.activitytype.v4.CreateFavouriteActivityTypeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.activitytype.v4.CreateFavouriteActivityTypeRequest;
  return proto.legebill.site.activitytype.v4.CreateFavouriteActivityTypeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.activitytype.v4.CreateFavouriteActivityTypeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.activitytype.v4.CreateFavouriteActivityTypeRequest}
 */
proto.legebill.site.activitytype.v4.CreateFavouriteActivityTypeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setActivityTypeId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.activitytype.v4.CreateFavouriteActivityTypeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.activitytype.v4.CreateFavouriteActivityTypeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.activitytype.v4.CreateFavouriteActivityTypeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.activitytype.v4.CreateFavouriteActivityTypeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActivityTypeId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string activity_type_id = 1;
 * @return {string}
 */
proto.legebill.site.activitytype.v4.CreateFavouriteActivityTypeRequest.prototype.getActivityTypeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.activitytype.v4.CreateFavouriteActivityTypeRequest} returns this
 */
proto.legebill.site.activitytype.v4.CreateFavouriteActivityTypeRequest.prototype.setActivityTypeId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    favouriteActivityTypeId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    siteListIndex: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeRequest}
 */
proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeRequest;
  return proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeRequest}
 */
proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFavouriteActivityTypeId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSiteListIndex(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFavouriteActivityTypeId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSiteListIndex();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
};


/**
 * optional string favourite_activity_type_id = 1;
 * @return {string}
 */
proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeRequest.prototype.getFavouriteActivityTypeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeRequest} returns this
 */
proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeRequest.prototype.setFavouriteActivityTypeId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 site_list_index = 2;
 * @return {number}
 */
proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeRequest.prototype.getSiteListIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeRequest} returns this
 */
proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeRequest.prototype.setSiteListIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeResponse}
 */
proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeResponse;
  return proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeResponse}
 */
proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.activitytype.v4.ReorderFavouriteActivityTypeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.activitytype.v4.DeleteFavouriteActivityTypeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.activitytype.v4.DeleteFavouriteActivityTypeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.activitytype.v4.DeleteFavouriteActivityTypeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.activitytype.v4.DeleteFavouriteActivityTypeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    favouriteActivityTypeId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.activitytype.v4.DeleteFavouriteActivityTypeRequest}
 */
proto.legebill.site.activitytype.v4.DeleteFavouriteActivityTypeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.activitytype.v4.DeleteFavouriteActivityTypeRequest;
  return proto.legebill.site.activitytype.v4.DeleteFavouriteActivityTypeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.activitytype.v4.DeleteFavouriteActivityTypeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.activitytype.v4.DeleteFavouriteActivityTypeRequest}
 */
proto.legebill.site.activitytype.v4.DeleteFavouriteActivityTypeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFavouriteActivityTypeId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.activitytype.v4.DeleteFavouriteActivityTypeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.activitytype.v4.DeleteFavouriteActivityTypeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.activitytype.v4.DeleteFavouriteActivityTypeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.activitytype.v4.DeleteFavouriteActivityTypeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFavouriteActivityTypeId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string favourite_activity_type_id = 1;
 * @return {string}
 */
proto.legebill.site.activitytype.v4.DeleteFavouriteActivityTypeRequest.prototype.getFavouriteActivityTypeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.activitytype.v4.DeleteFavouriteActivityTypeRequest} returns this
 */
proto.legebill.site.activitytype.v4.DeleteFavouriteActivityTypeRequest.prototype.setFavouriteActivityTypeId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.activitytype.v4.ListRecentActivityTypesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.activitytype.v4.ListRecentActivityTypesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.activitytype.v4.ListRecentActivityTypesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.activitytype.v4.ListRecentActivityTypesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pageSize: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.activitytype.v4.ListRecentActivityTypesRequest}
 */
proto.legebill.site.activitytype.v4.ListRecentActivityTypesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.activitytype.v4.ListRecentActivityTypesRequest;
  return proto.legebill.site.activitytype.v4.ListRecentActivityTypesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.activitytype.v4.ListRecentActivityTypesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.activitytype.v4.ListRecentActivityTypesRequest}
 */
proto.legebill.site.activitytype.v4.ListRecentActivityTypesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.activitytype.v4.ListRecentActivityTypesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.activitytype.v4.ListRecentActivityTypesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.activitytype.v4.ListRecentActivityTypesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.activitytype.v4.ListRecentActivityTypesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.legebill.site.activitytype.v4.ListRecentActivityTypesRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.activitytype.v4.ListRecentActivityTypesRequest} returns this
 */
proto.legebill.site.activitytype.v4.ListRecentActivityTypesRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint32 page_size = 2;
 * @return {number}
 */
proto.legebill.site.activitytype.v4.ListRecentActivityTypesRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.legebill.site.activitytype.v4.ListRecentActivityTypesRequest} returns this
 */
proto.legebill.site.activitytype.v4.ListRecentActivityTypesRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.legebill.site.activitytype.v4.ListRecentActivityTypesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.activitytype.v4.ListRecentActivityTypesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.activitytype.v4.ListRecentActivityTypesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.activitytype.v4.ListRecentActivityTypesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.activitytype.v4.ListRecentActivityTypesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    recentActivityTypesList: jspb.Message.toObjectList(msg.getRecentActivityTypesList(),
    legebill_type_activity_type_pb.ActivityType.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.activitytype.v4.ListRecentActivityTypesResponse}
 */
proto.legebill.site.activitytype.v4.ListRecentActivityTypesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.activitytype.v4.ListRecentActivityTypesResponse;
  return proto.legebill.site.activitytype.v4.ListRecentActivityTypesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.activitytype.v4.ListRecentActivityTypesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.activitytype.v4.ListRecentActivityTypesResponse}
 */
proto.legebill.site.activitytype.v4.ListRecentActivityTypesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new legebill_type_activity_type_pb.ActivityType;
      reader.readMessage(value,legebill_type_activity_type_pb.ActivityType.deserializeBinaryFromReader);
      msg.addRecentActivityTypes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.activitytype.v4.ListRecentActivityTypesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.activitytype.v4.ListRecentActivityTypesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.activitytype.v4.ListRecentActivityTypesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.activitytype.v4.ListRecentActivityTypesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecentActivityTypesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      legebill_type_activity_type_pb.ActivityType.serializeBinaryToWriter
    );
  }
};


/**
 * repeated legebill.type.ActivityType recent_activity_types = 1;
 * @return {!Array<!proto.legebill.type.ActivityType>}
 */
proto.legebill.site.activitytype.v4.ListRecentActivityTypesResponse.prototype.getRecentActivityTypesList = function() {
  return /** @type{!Array<!proto.legebill.type.ActivityType>} */ (
    jspb.Message.getRepeatedWrapperField(this, legebill_type_activity_type_pb.ActivityType, 1));
};


/**
 * @param {!Array<!proto.legebill.type.ActivityType>} value
 * @return {!proto.legebill.site.activitytype.v4.ListRecentActivityTypesResponse} returns this
*/
proto.legebill.site.activitytype.v4.ListRecentActivityTypesResponse.prototype.setRecentActivityTypesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.legebill.type.ActivityType=} opt_value
 * @param {number=} opt_index
 * @return {!proto.legebill.type.ActivityType}
 */
proto.legebill.site.activitytype.v4.ListRecentActivityTypesResponse.prototype.addRecentActivityTypes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.legebill.type.ActivityType, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.legebill.site.activitytype.v4.ListRecentActivityTypesResponse} returns this
 */
proto.legebill.site.activitytype.v4.ListRecentActivityTypesResponse.prototype.clearRecentActivityTypesList = function() {
  return this.setRecentActivityTypesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.legebill.site.activitytype.v4.GetActivityTypeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.legebill.site.activitytype.v4.GetActivityTypeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.legebill.site.activitytype.v4.GetActivityTypeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.activitytype.v4.GetActivityTypeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.legebill.site.activitytype.v4.GetActivityTypeRequest}
 */
proto.legebill.site.activitytype.v4.GetActivityTypeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.legebill.site.activitytype.v4.GetActivityTypeRequest;
  return proto.legebill.site.activitytype.v4.GetActivityTypeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.legebill.site.activitytype.v4.GetActivityTypeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.legebill.site.activitytype.v4.GetActivityTypeRequest}
 */
proto.legebill.site.activitytype.v4.GetActivityTypeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.legebill.site.activitytype.v4.GetActivityTypeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.legebill.site.activitytype.v4.GetActivityTypeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.legebill.site.activitytype.v4.GetActivityTypeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.legebill.site.activitytype.v4.GetActivityTypeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.legebill.site.activitytype.v4.GetActivityTypeRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.legebill.site.activitytype.v4.GetActivityTypeRequest} returns this
 */
proto.legebill.site.activitytype.v4.GetActivityTypeRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.legebill.site.activitytype.v4);
